import React, {useEffect} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {useLoaderData, useParams} from "react-router";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../services/web/bos-service.js";

const BoRedirect = () => {
    const {id: idRaw} = useParams();
    const id = idRaw?.replace("-", "/");

    const navigate = navigateHook();

    const loaderData = useLoaderData();

    const {data, isError} = useQuery({
        queryFn: () => bosService.getBoInfo(idRaw),
        queryKey: ["bo-info", idRaw],
        enabled: !!idRaw
    });

    useEffect(() => {
        if (!data) return;

        const { status, has_data, has_occurrencefile } = data;
        const prodUrl = `/bos/${idRaw}`;

        let targetPath = `/bo/last-status/${idRaw}`;

        if (status === "DRAFT" || (has_data && !has_occurrencefile)) {
            targetPath = `/bo/show/${idRaw}`;
        }
        else if (status === "NUMBER_GENERATED" || (!has_data && has_occurrencefile)) {
            targetPath = `/bo/${idRaw}`;
        }

        navigate(targetPath);
    }, [data]);

    useEffect(() => {
        if (isError) navigate("/404");
    }, [isError]);

    return (
        <Template isLoading={true}>
            <Template.Header>
                <Template.Title className={"flex gap-2 items-center"}>
                    {loaderData?.bo_name} {id}
                </Template.Title>
            </Template.Header>
        </Template>
    );
};

export default BoRedirect;